<header class="header" id="main-header">
	<div [ngClass]="{'mobile-menu-active': showMobileMenu}" class="grid-container grid-nav row" id="header-top">
		<div class="grid-item">
			<button (click)="toggleMobileMenu()" class="header-hamburger theme-primary-text-color">
				<div class="header-hamburger-icon">
					<span>Menu</span>
				</div>
			</button>
		</div>

		<div class="grid-item">
			<a class="header-logo" href="{{ getLogo().linkToCms ? applicationService.getCmsUrl() : '/'}}">
				<img [alt]="getShopName()"
				     height="{{getLogo().height}}"
				     src="{{getLogo().src}}"
				     srcset="{{getLogo().srcSet}}" />
			</a>
		</div>

		<div class="grid-item">
			<nav class="header-nav" id="header-nav">
				<ul>
					<li [ngClass]="{active: isAssortmentActive()}">
						<a [href]="assortmentUrl">
							<span i18n="Assortment menu item@@menu.item.assortment">Assortment</span>
						</a>
					</li>

					@if (showPlantscapingMenuItem || showPlantscapingMenuItemForKvk) {
						<li [ngClass]="{active: isPlantscapingActive()}">
							<a [href]="plantscapingUrl">
								<span i18n="Plantscaping menu item@@menu.item.plantscaping">Plantscaping</span>
							</a>
						</li>
					}

					@if (isKvkShop()) {
						<!-- Render blog menu item if this is a kvk shop)-->
						<li [ngClass]="{active: isBlogsActive()}">
							<a [routerLink]="['/blogs']">
								<span i18n="Blog menu item@@menu.item.blogs">Blogs</span>
							</a>
						</li>

						<!-- Render hunters menu item if this is a kvk shop)-->
						@if (showHuntersForKvkShop()) {
							<li [ngClass]="{active: isHuntersActive()}">
								<a [routerLink]="['/hunters']">
									<span i18n="Hunters menu item@@menu.item.hunters">Hunters</span>
								</a>
							</li>
						}
					} @else {
						@for (menu of getMainMenuItems(); track trackByMenuItem($index, menu)) {
							<li>
								<a href="{{ menu.url }}">
									<span>{{ menu.text }}</span>
									@if (isHunterMenuItem(menu.text)) {
										<planthunter-amountofnewhunts-component></planthunter-amountofnewhunts-component>
									}
								</a>
							</li>
						}
					}
				</ul>
			</nav>
		</div>

		<div class="grid-item">
			<div class="grid-container inner-grid">
				<div>
					<language-select></language-select>
				</div>

				<div>
					@if (getUser()) {
						<a [ngClass]="{'header-user--mynovi': showMyTabs()}"
						   [routerLink]="['/my/pending/orders']"
						   aria-label="Orders"
						   class="header-user theme-btn-primary-outline">
							<svg class="icon-user" height="22px" width="15px">
								<use xlink:href="/images/icons/svg-sprite.svg#user"></use>
							</svg>
							<span>{{ getUser().name }}</span>
						</a>
					}

					@if (!getUser()) {
						<a [routerLink]="['/login']"
						   aria-label="Login"
						   class="header-user theme-btn-primary-outline">
							<svg class="icon-user" height="22px" width="15px">
								<use xlink:href="/images/icons/svg-sprite.svg#user"></use>
							</svg>

							<span i18n="Sign in button, when not logged in@@sign.in.button">Sign in</span>
						</a>
					}
				</div>

				<div>
					@if (getUser()) {
						<shoppingcart-header-mobile-component (viewOrderDetailClickEvent)="viewOrderDetail()"
						                                      (viewShoppingcartClickEvent)="viewShoppingcart()">
						</shoppingcart-header-mobile-component>
					}
				</div>
			</div>
		</div>
	</div>

	<div class="header-shopping-info theme-primary-color" id="header-shopping">
		@if (getUser()) {
			<div class="row">
				<shoppingcart-header-component (viewOrderDetailClickEvent)="viewOrderDetail()"
				                               (viewPendingOrdersClickEvent)="viewPendingOrders()"
				                               (viewShoppingcartClickEvent)="viewShoppingcart()"
				                               [showShoppingCart]="showShoppingCart()">
				</shoppingcart-header-component>

				<navbar-tabs></navbar-tabs>
			</div>
		}
	</div>
</header>

@if (applicationService.showMessage()) {
	<show-message></show-message>
}

@if (applicationService.isShowPopup()) {
	<start-order (closed)="applicationService.onStartOrderPopupCloseCallback()"
	             (saved)="applicationService.onStartOrderPopupSaveCallback($event)">
	</start-order>
}
